import type { GetAssignableUsersResponse, JsonObject } from '@/app-package';
import axios from 'axios';

export type AssignableUsers = JsonObject<GetAssignableUsersResponse>;

const getAssignableUsers = async () => {
  const { data } = await axios.get<AssignableUsers>(`/lockbox/users`);

  return data;
};

export default getAssignableUsers;
